import { TimeSlot } from '../@types';
import { RequestApi } from '../helpers';

const getTimeSlotsForDate = async (date: string) => {
  const response = await RequestApi.get<TimeSlot[]>(
    `/skatingSessions/available/${date}`,
  );
  return response;
};

const createTicketBooking = async (userData: FormData) => {
  const response = await RequestApi.post(
    '/skatingSessions/createTicketBooking',
    userData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

const ticketService = {
  getTimeSlotsForDate,
  createTicketBooking,
};

export default ticketService;
